export function getLocalData(name) {
  const data = localStorage.getItem(name);
  return data ? JSON.parse(data) : null;
}

export function setLocalData(name, value) {
  localStorage.setItem(name, JSON.stringify(value || null));
}

export function removeLocalData(name) {
  localStorage.removeItem(name);
}

export function mergeLocalData(name, obj) {
  setLocalData(Object.assign(getLocalData(), obj));
}

export const getLastGame = () => getLocalData('last_game') || '';
export const setLastGame = gameName => setLocalData('last_game', gameName);

export const getMaintenanceMode = () => getLocalData('maintenance_mode') || {};
export const setMaintenanceMode = m => setLocalData('maintenance_mode', m);



// WEBPACK FOOTER //
// ./src/utils/localStorage.js